import mutationsTypes from '@/store/mutationTypes'
import axios from 'axios'
import api from '@/config/api'
import apiMock from '@/config/apiMock'
import store from '@/store/index'
import { commonUtil } from '@/util'
import getCsrfToken from '@/store/Csrf'
import requestPlatformEdit from './request/requestPlatformEdit'
import requestPlatformRegister from './request/requestPlatformRegister'

const Actions = {
  // PLT02 プラットフォーム登録
  registerPlatform: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()

    let req = requestPlatformRegister.request.createRequest(params)
    return await axios
      // .get(apiMock.PLATFORM_REGISTER_EDIT)
      .post(api.PLATFORM_REGISTER_EDIT, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // PLT01 プラットフォーム一覧取得
  getPlatformListFromApi: async ({
    state,
    dispatch,
    commit,
    getters,
    rootGetters,
    rootState
  }) => {
    const ret = await axios
      // .get(apiMock.PLATFORM_LIST)
      .get(api.PLATFORM_LIST)
      .then((response) => {
        const path = mutationsTypes.PLATFORM_SET_PLATFORM_LIST
        commit(path, response.data)

        const getData = getters.getPlatformListFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // uiControll.commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
    return ret
  },
  // PLT03 プラットフォーム編集
  editPlatform: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()

    let req = requestPlatformEdit.request.createRequest(params)
    return await axios
      // .get(apiMock.PLATFORM_REGISTER_EDIT)
      .patch(`${api.PLATFORM_REGISTER_EDIT}/${params.platformId}`, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  }
}

export default Actions
